module.exports = __webpack_public_path__ + "static/fish-fry-lunch-menu-60732913116ea6dd1dc7118c58a16d4c.png";